<div class="challenges-widget">
  <lib-swiper class="challenges-swiper" [slides]="challenges" [options]="carouselConfig">
    <ng-template swiperContent let-item="item">
      <div class="challenge-card">
        <div class="challenge-avatar" [cropImage]="item.mediaImage | preSignedUrl | async"></div>

        <div class="challenge-title">{{ item.title }}</div>  

        <div class="challenge-actions">
          @if (item.isOngoing && !item.isJoined) {
            <button mat-flat-button class="button button--primary" (click)="joinChallenge.emit(item)">
              {{ (item.progress ? 'CHALLENGE.continue_challenge' : 'CHALLENGE.join_challenge') | translate }}
            </button>
          }

          <button mat-flat-button class="button button--outline" (click)="navigateToChallenge.emit(item)">
            {{ 'COMMON.see_details' | translate }}
          </button>
        </div>
      </div>
    </ng-template>
  </lib-swiper>

  @if (challenges?.length > 1) {
    <div class="challenges-pager" [style.color]="textColor">
      <button
        class="button button--icon button--transparent"
        mat-icon-button
        [disabled]="swiperComponent?.swiper?.isBeginning"
        (click)="swiperComponent?.swiper?.slidePrev()"
         aria-label="Previous">
        <lib-icon icon="arrow-left"></lib-icon>
      </button>
      <div class="challenges-pager-counter">
        {{swiperComponent?.swiper?.activeIndex + 1}} / {{ challenges?.length}}
      </div>
      <button
        class="button button--icon button--transparent"
        mat-icon-button
        [disabled]="swiperComponent?.swiper?.isEnd"
        (click)="swiperComponent?.swiper?.slideNext()"
         aria-label="Next">
        <lib-icon icon="arrow-right"></lib-icon>
      </button>
    </div>
  }
</div>
